import Text from '@cartwhl/ui/base/Text';
import { useModal } from 'modals';

import GreenLink from 'components/GreenLink';

export default function TrialSection() {
  const { open } = useModal();

  return (
    <section className="pb-(--vertical-spacing)">
      <div className="container">
        <Text
          as="h2"
          variant="web/display/xl"
          lg:variant="web/display/3xl"
          className="max-w-[720px]"
        >
          Not sure yet?
        </Text>
        <Text
          as="p"
          variant="web/body/medium/md"
          lg:variant="web/body/medium/24"
          className="text-secondary mt-6 max-w-[680px]"
        >
          We offer time-limited API trials for teams evaluating Cartwheel for
          production workflows.
        </Text>
        <GreenLink onClick={() => open('ENTERPRISE_CONTACT', { reason: 'pilot_cartwheel' })} className="mt-12">
          Request a trial
        </GreenLink>
      </div>
    </section>
  );
}
